import { invoiceStatusSchema } from '../../../schemas'
import { searchStringSchema } from '../../../schemas/search-string-schema'

export const readAllBatchChargeInvoicesSchemas = invoiceStatusSchema.concat(searchStringSchema)
